import { render, staticRenderFns } from "./book-unit.vue?vue&type=template&id=1b5a0cac&"
import script from "./book-unit.vue?vue&type=script&lang=js&"
export * from "./book-unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports